import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
// import {Row, Col} from 'react-flexbox-grid'
// import format from '../../helpers/format'
import config from '../../config'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  BenchmarkGridTable
} from '../../components'
import Styles from './BenchmarkGrid.css'


@CSSModules(Styles,{allowMultiple:true})
export default class BenchmarkGrid extends Component {
  render() {
    let gradeField = null
    let gradeName = null
    switch (config.app.title) {
      case 'Fossil Free Funds':
        gradeField = 'grade_fossil'
        gradeName = 'fossil fuel'
        break
      case 'Deforestation Free Funds':
        gradeField = 'grade_deforestation'
        gradeName = 'deforestation'
        break
      case 'Weapon Free Funds':
        gradeField = 'grade_military'
        gradeName = 'military weapons'
        break
      case 'Gun Free Funds':
        gradeField = 'grade_guns'
        gradeName = 'civilian firearms'
        break
      case 'Tobacco Free Funds':
        gradeField = 'grade_tobacco'
        gradeName = 'tobacco'
        break
      case 'Gender Equality Funds':
        gradeField = 'grade_gender_equality'
        gradeName = 'gender equality'
        break
      case 'Prison Free Funds':
        gradeField = 'grade_prison_industrial_complex'
        gradeName = 'prison industrial complex'
        break
      default:
        break
    }

    return <div styleName='benchmark-grid-wrap'>
      <div styleName='anchor' id='companies' />
      <ContainerDivs>
        <div>
          <div styleName='companies-title'>
            Index funds
          </div>
          <div styleName='companies-info'>
            Passively managed investment funds that track market indexes have seen significant fund inflows over the past decade.

            These indexes, from firms like from S&P Global Ratings, Russell/FTSE, and MSCI, are increasingly setting our economy
            on autopilot and pumping capital into unsustainable business models.
          </div>
        </div>

        <BenchmarkGridTable gradeField={gradeField} gradeName={gradeName}/>

        <div styleName='companies-more-link'>
          <Link
            to={config.routes.clean}
            title='Search funds'
            roundbutton
          >
            More funds<LinkIcon />
          </Link>
        </div>
      </ContainerDivs>
    </div>
  }
}
